import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { unsafeUseFormReturnSubset } from '@ipfabric/ui-components/utils/formSnippets/unsafeUseFormReturnSubset';
import { CliSessions } from 'app/features/DiscoverySettingsForms/components/CliSettings/CliSessions';
import { FailureHandling } from 'app/features/DiscoverySettingsForms/components/CliSettings/FailureHandling';
import { TimeoutSettings } from 'app/features/DiscoverySettingsForms/components/CliSettings/TimeoutSettings';
import {
  type AuthenticationFailureFieldValues,
  authenticationFailure,
} from 'app/features/DiscoverySettingsForms/snippets/advancedCli/authenticationFailure';
import {
  type AuthorizationFailureFieldValues,
  authorizationFailure,
} from 'app/features/DiscoverySettingsForms/snippets/advancedCli/authorizationFailure';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { allowTelnet } from '../../../snippets/advancedCli/allowTelnet';
import {
  type BasicFailureFieldValues,
  basicFailure,
} from '../../../snippets/advancedCli/basicFailure';
import { cliSessions } from '../../../snippets/advancedCli/cliSessions';
import {
  type CommandResponseFieldValues,
  commandResponse,
} from '../../../snippets/advancedCli/commandResponse';
import { customPorts } from '../../../snippets/advancedCli/customPorts';
import {
  type DeviceAuthenticationFieldValues,
  deviceAuthentication,
} from '../../../snippets/advancedCli/deviceAuthentication';
import {
  type LoginTimeoutFieldValues,
  loginTimeout,
} from '../../../snippets/advancedCli/loginTimeout';
import {
  type SessionTimeoutFieldValues,
  sessionTimeout,
} from '../../../snippets/advancedCli/sessionTimeout';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const advancedCliGroup = createFormSnippetGroup({
  snippets: {
    allowTelnet,
    authenticationFailure,
    authorizationFailure,
    basicFailure,
    cliSessions,
    commandResponse,
    customPorts,
    deviceAuthentication,
    loginTimeout,
    sessionTimeout,
  },
  render: ({ renderSnippet, form }) => (
    <div className='flex-1 flex flex-col gap'>
      <div className='text-default text-level-4 font-semibold font-heading'>
        Advanced CLI
      </div>
      <SearchableSection id='advanced-cli-timeouts'>
        <TimeoutSettings
          form={unsafeUseFormReturnSubset(form)<
            | keyof LoginTimeoutFieldValues
            | keyof SessionTimeoutFieldValues
            | keyof CommandResponseFieldValues
            | keyof DeviceAuthenticationFieldValues
          >()}
          renderSnippet={renderSnippet}
        />
      </SearchableSection>
      <SearchableSection id='advanced-cli-failure-handling'>
        <FailureHandling
          form={unsafeUseFormReturnSubset(form)<
            | keyof BasicFailureFieldValues
            | keyof AuthenticationFailureFieldValues
            | keyof AuthorizationFailureFieldValues
          >()}
          renderSnippet={renderSnippet}
        />
      </SearchableSection>
      <SearchableSection id='advanced-cli-sessions'>
        <CliSessions renderSnippet={renderSnippet} />
      </SearchableSection>
      <div className='rounded-lg bg-default'>
        <SearchableSection
          id='advanced-cli-custom-ports'
          searchTerms={['Custom SSH/Telnet ports']}
          highlightOn={['advancedCli']}
        >
          {renderSnippet('customPorts')}
        </SearchableSection>
      </div>
    </div>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('advancedCli');
  },
});
